import { Box, Stack, Typography } from '@mui/material'

type SectionSubheadingProps = {
  title: string
  description?: React.ReactNode
  action?: React.ReactNode
}
/**
 * @description Small heading used to split a section into related groups (e.g. "Address" and "Parking Lots"
 * within Location).
 */
const SectionSubheading = (props: SectionSubheadingProps) => {
  const { title, description, action } = props
  return (
    <Stack
      direction={{ zero: 'column', sm: 'row' }}
      alignItems={{ zero: 'stretch', sm: 'center' }}
      justifyContent="space-between"
      spacing={{ zero: 1, sm: 2 }}
    >
      <Box>
        <Typography
          variant="overline"
          component="h4"
          sx={{ color: 'primary.main', fontWeight: 700, lineHeight: 1.6, display: 'block' }}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="grey.400">
            {description}
          </Typography>
        )}
      </Box>
      {action && (
        <Box sx={{ flexShrink: 0, '& > .MuiButton-root': { width: { zero: '100%', sm: 'auto' } } }}>{action}</Box>
      )}
    </Stack>
  )
}
export default SectionSubheading
